<script>
  import { Tabs } from 'element-ui'
  export default {
    name:'ElTabs',
    extends:Tabs
  }
</script>
